import { useAppSelector } from "../../util/hooks";
import CadastrarPage from "./pages/cadastrar";
import GeralPage from "./pages/geral";

const pages: any = {
  geral: GeralPage,
  cadastrar: CadastrarPage,
};

const PessoaPageController = () => {
  //estados globais
  const pessoaState = useAppSelector((state) => state.pessoa);

  const Page = pages[pessoaState.page];

  return <Page key={pessoaState.page} />;
};

export default PessoaPageController;
